var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "DialogReportHistory__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("רשימת ספקים לעירייה " + _vm._s(_vm.municipality.Municipality))
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _vm.providers.length
          ? _c("div", { staticClass: "history-container" }, [
              _c(
                "table",
                { staticClass: "table" },
                [
                  _vm._m(0),
                  _vm._l(_vm.providers, function(provider, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(provider.Id))]),
                      _c("td", [
                        _vm._v(_vm._s(provider.IsInApi ? "כן" : "לא"))
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            provider.FromDate
                              ? _vm.parseDate(provider.FromDate)
                              : ""
                          )
                        )
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            provider.ToDate
                              ? _vm.parseDate(provider.ToDate)
                              : ""
                          )
                        )
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(provider.Scraper ? provider.Scraper.Name : "")
                        )
                      ]),
                      _c("td", [_vm._v(_vm._s(provider.ScraperCityId))]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            provider.PaymentProvider
                              ? provider.PaymentProvider.Name
                              : ""
                          )
                        )
                      ]),
                      _c("td", [
                        _vm._v(_vm._s(provider.PaymentProviderCityId))
                      ]),
                      _c("td", [_vm._v(_vm._s(provider.PaymentUrlCityId))]),
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticStyle: { "text-decoration": "underline" },
                            attrs: {
                              target: "_blank",
                              href: provider.PaymentUrlBase
                            }
                          },
                          [_vm._v("קישור")]
                        )
                      ])
                    ])
                  })
                ],
                2
              )
            ])
          : _vm._e(),
        !_vm.providers.length ? _c("h1", [_vm._v("אין ספקים")]) : _vm._e()
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: { label: "סגור" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(" מזהה ")]),
        _c("th", [_vm._v(" האם קיים בAPI ")]),
        _c("th", [_vm._v(" מתאריך ")]),
        _c("th", [_vm._v(" עד תאריך ")]),
        _c("th", [_vm._v(" סקראפר ")]),
        _c("th", [_vm._v(" מזהה עיר לסקראפר ")]),
        _c("th", [_vm._v(" ספק תשלום ")]),
        _c("th", [_vm._v(" מזהה עיר לספק תשלום ")]),
        _c("th", [_vm._v(" מזהה עיר לתשלום ")]),
        _c("th", [_vm._v(" קישור לתשלום ")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }